import { FormControlLabel, TextField, Switch } from '@mui/material';
import { MarketingConsentObject } from 'common/types';
import React from 'react';
import { useTranslation } from 'services/localization';

interface Props {
	value?: MarketingConsentObject;
	onChange: (marketingConsentText: MarketingConsentObject) => void;
}

const MarketingConsent = (props: Props) => {
	const { value, onChange } = props;
	const { t } = useTranslation();

	const toggleCustomConsent = (event: React.ChangeEvent<HTMLInputElement>) => {
		const checked = event.target.checked;
		onChange({
			...value,
			text: value
				? {
						...value.text,
				  }
				: {
						def: '',
				  },
			active: checked,
		});
	};

	const handleMarketingConsentTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const consent = event.target.value;
		onChange({
			...value,
			text: value
				? {
						...value.text,
						def: consent,
				  }
				: {
						def: consent,
				  },
			active: value ? value.active : false,
		});
	};

	return (
		<>
			<FormControlLabel
				style={{ alignItems: 'center' }}
				control={
					<Switch
						color="primary"
						checked={value ? value.active : false}
						onChange={toggleCustomConsent}
						value="customConsentText"
					/>
				}
				label={t('shop.useCustomMarketingConsent', 'Use custom marketing consent')}
			/>
			<TextField
				id="marketing-consent"
				label={t('shop.consentTextLabel', 'Consent text')}
				InputLabelProps={{
					shrink: true,
				}}
				multiline
				rows={4}
				variant="outlined"
				fullWidth
				maxRows="4"
				value={
					!value?.active
						? t(
								'shop.marketingConsentText2',
								'You may send me additional information and benefits related to my order',
						  )
						: value.text.def
				}
				onChange={handleMarketingConsentTextChange}
				margin="normal"
				type="text"
				disabled={!value?.active ? true : false}
				placeholder={t('shop.defaultMarketingConsentTextLabel', 'Default marketing consent text')}
			/>
		</>
	);
};

export default MarketingConsent;
